import { IRecipientMedicalDetails } from '@nkr/models/index';

interface IValidation {
    dialysisStartDate: boolean,
    birthDate: boolean,
    weightKgs: boolean,
    weightLbs: boolean
}

interface IState {
    data: IRecipientMedicalDetails,
    showMetric: boolean,
    hash: string,
    hasDataChanged: boolean,
    heightCm: number,
    heightInches: number,
    heightFeet: number,
    weightKgs: number,
    weightLbs: number,
    validation: IValidation,
    alertMessage: number,
}

const initialState: IState = {
    showMetric: false,
    heightCm: 0,
    heightInches: 0,
    heightFeet: 0,
    weightKgs: 0,
    weightLbs: 0,
    data: {
        birthDate: '',
        birthYear: 0,
        isOnDialysis: false,
        bloodType: '',
        dialysisStartDate: '',
        antiATiter: 0,
        antiATiterValue: 0,
        isAboConfirmed: false,
        height: 0,
        heightInches: 0,
        weight: 0,
        weightLbs: 0,
        reasonForKidneyFailure: '',
        ebv: '',
        gender: '',
        cmv: '',
        race: '',
        unosDate: '',
        medComments: '',
        hasDiabetes: null,
        histogeneticsAbo: ''
    },
    hash: '',
    hasDataChanged: false,
    validation: {
        dialysisStartDate: true,
        birthDate: true,
        weightKgs: true,
        weightLbs: true
    },
    alertMessage: 0,
};

const medicalDetailsReducer = (state: IState, action): IState => {
    if (action.type == 'afterLoad') {
        return {
            ...state,
            data: action.value.data,
            hash: action.value.hash,
        };
    }

    if (action.type == 'updateHash') {
        return { ...state, hash: action.value };
    }

    if (action.type == 'updateData') {
        return { ...state, data: action.value };
    }

    if (action.type == 'convertWeight') {
        return { ...state, data: action.value.data, weightLbs: action.value.weightLbs };
    }

    if (action.type == 'convertHeight') {
        return { ...state, data: action.value.data, heightFeet: action.value.heightFeet, heightInches: action.value.heightInches };
    }

    if (action.type == 'loadUSMetrics') {
        return { ...state, weightLbs: action.value.weightLbs, heightFeet: action.value.heightFeet, heightInches: action.value.heightInches };
    }

    if (action.type == 'updateValidation') {
        return { ...state, validation: action.value };
    }

    if (action.type == 'toggleMetric') {
        return { ...state, showMetric: action.value };
    }

    return { ...state };
};


export { IValidation, IState, initialState, medicalDetailsReducer };